import {Component, Input, OnChanges, OnInit, SimpleChanges } from 'ng-metadata/core';
const  partition = require('lodash/partition');
import {IRecommendedResource} from './recommendedResource';
import {MediaQueries} from "../../infra/mediaQueries.service";
const includes = require('lodash/includes');
const libraryResources = ['library_information', 'library_guide', 'person'];

@Component({
    selector: 'prm-resource-recommender-full-view',
    templateUrl: 'components/search/resourceRecommender/resource-recommender-full-view.html',
})

export class PrmResourceRecommenderFullView {
    @Input() private resources: IRecommendedResource[];
    @Input() private query: string;
    private libraryResources: IRecommendedResource[];
    private otherResources: IRecommendedResource[];

    constructor( private mediaQueries: MediaQueries){}

    ngOnInit() {
        [this.libraryResources, this.otherResources] = partition(this.resources, (r) => includes (libraryResources, r.resourceType));
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/resourceRecommenderFullView.directive.ts